import { useCallback, useEffect, useRef } from 'react';
import { useFormMessageEvents } from './useFormMessageEvents';
import { useV1FormThemeCss } from './useV1FormThemeCss';
import { useInjectIframeStyles } from './useInjectIframeStyles';
import { getFormsDomain, injectScript } from './formScript';
import { jsx as _jsx } from "react/jsx-runtime";
export function VersionOneForm({
  formId,
  portalId,
  env,
  region,
  dispatch
}) {
  const containerId = useRef(`hs-form-container-${formId}-${Math.random().toString(36).slice(2, 8)}`);
  const themeCss = useV1FormThemeCss();
  const injectStyles = useInjectIframeStyles(containerId.current, themeCss);
  const themedDispatch = useCallback(eventName => {
    if (eventName === 'onFormReady') {
      injectStyles();
    }
    dispatch(eventName);
  }, [dispatch, injectStyles]);
  useEffect(() => {
    injectStyles();
  }, [injectStyles]);
  const renderForm = useCallback(() => {
    // @ts-expect-error hbspt is injected by the embed script
    window.hbspt.forms.create({
      portalId,
      formId,
      region,
      env,
      target: `#${containerId.current}`
    });
  }, [formId, portalId, env, region]);
  useEffect(() => {
    injectScript(`//js.${getFormsDomain(env)}/forms/embed/v2.js`, renderForm);
  }, [env, renderForm]);
  useFormMessageEvents(formId, themedDispatch);
  return /*#__PURE__*/_jsx("div", {
    id: containerId.current
  });
}